<template>
  <transition name="modal">
    <div class="modal-mask" @click.self="hide">
      <div class="modal-wrapper" @click.self="hide">
        <div class="modal-dialog">
          <div class="modal-share modal-content">
            <div class='modal-header modal-confirmation-icon__header'>
              <button class='modal__close-btn' @click="hide" type='button'>
                <i class='kf kf-x'></i>
                <div class='sr-only'>Close</div>
              </button>
            </div>
            <div class='modal-body'>
              <div class='center txt-c'>
                <div class='modal-share__icon kf-stack kf-stack--circle' aria-hidden='true'>
                  <i class='kf kf-circle-outline'></i>
                  <i class='kf kf-share'></i>
                </div>
                <h4 class='modal-confirmation__title mt0'>{{modal_title}}</h4>
                <p class='bold mt0' v-if='modal_description'>{{modal_description}}</p>
              </div>
              <div class='modal-share__share-group' v-if='!privateSharing'>
                <a class='modal-share__share-btn kf-stack kf-stack--circle' href='javascript:;' v-tooltip="{content: 'Facebook'}" :data-share-link='share_url' :data-share-name='share_title' :data-share-description='share_desc' data-share-facebook='true' aria-label='Facebook'>
                  <i class='kf kf-circle-fill'></i>
                  <i class='kf kf-inverse kf-social-facebook'></i>
                </a>
                <a class='modal-share__share-btn kf-stack kf-stack--circle' href='javascript:;' v-tooltip="{content: 'Twitter'}" :data-share-link='share_url' :data-share-description='share_title' :data-share-twitter='true' aria-label='Twitter'>
                  <i class='kf kf-circle-fill'></i>
                  <i class='kf kf-inverse kf-social-twitter'></i>
                </a>
                <a class='modal-share__share-btn kf-stack kf-stack--circle' href='javascript:;' v-tooltip="{content: 'Tumblr'}" :data-share-link='share_url' :data-share-tumblr='true' aria-label='Tumblr'>
                  <i class='kf kf-circle-fill'></i>
                  <i class='kf kf-inverse kf-social-tumblr'></i>
                </a>
              </div>
              <div class='modal-share__share-link' v-if='!emailSharing'>
                <div class='kd-form__copy-link'>
                  <div class='kd-form__text-input'>
                    <div class='kd-form__copy-link_icon' aria-hidden='true'>
                      <i class='kf kf-link'></i>
                    </div>
                    <input id='js-modal-share-url' type='text' readonly='readonly' v-model='share_url'>
                  </div>
                  <div class='kd-form__copy-link_bottom'>
                    <button class='kd-form__btn' id='js-copy-url' href='javascript:;' data-clipboard-target='#js-modal-share-url'>Copy URL</button>
                    <div class='kd-form__copy-link_message' v-if='share_url_copied'>
                      <div class='kd-form__copy-message'>
                        <i class='kf kf-checkmark txt-clr--success'></i>
                        <span></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class='modal-footer modal-confirmation__footer'></div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    props: {
      shareableObj: {
        type: Object
      },
      modal_title: {
        type: String,
        default: 'Share'
      },
      modal_description: {
        type: String
      },
      emailShareCb: {
        type: Function
      },
      privateSharing: {
        type: Boolean,
        default: false
      },
      attrs: {
        type: Object,
        default: function() {
          return {
            title: 'title',
            description: 'description',
            url: 'share_url'
          };
        }
      }
    },
    data() {
      return {
        share_url_copied: false,
        emailSharing: false,
        shareEmails: ''
      };
    },
    computed: {
      share_title() {
        return this.shareableObj && this.shareableObj[this.attrs['title']];
      },

      share_desc() {
        return this.shareableObj && this.shareableObj[this.attrs['description']];
      },

      share_url() {
        return this.shareableObj && this.shareableObj[this.attrs['url']];
      }
    },
    methods: {
      init() {
        Kadenze.Share.init();
        let self = this;

        // (new Kadenze.KdForms()).initField(document.getElementById('share-emails-textarea'))

        let clipboard = new Clipboard('#js-copy-url');
        clipboard.on('success', function (e) {
          self.share_url_copied = true;
        });

      },
      hide() {
        this.$emit('close');
      },
      hideEmailScreen() {
        this.emailSharing = false;
        this.shareEmails = '';
      },
      sendShareEmail() {
        if (typeof this.emailShareCb == 'function') {
          this.emailShareCb.call(this, this.shareableObj, this.shareEmails.split(','));
        } else {
          console.warn('No e-mail function specified in the configuration. No e-mails were sent :(');
        }
        this.hideEmailScreen();
        this.hide();
      },

      // areEmailsValid() {

      // }
    },
    mounted() {
      this.init();
    }
  }
</script>
